var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgLogoMini = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 117,
    height: 104,
    viewBox: "0 0 117 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M111.653 11.301C125.004 28.6622 112.021 61.0429 82.6546 83.6253C53.2884 106.208 18.6596 110.44 5.30898 93.0789C-8.04168 75.7177 4.94139 43.337 34.3076 20.7546C63.6738 -1.82773 98.3027 -6.06028 111.653 11.301ZM67.4344 45.3035C69.6843 48.2293 67.4984 53.6846 62.5521 57.4882C57.6058 61.2919 51.7722 62.0035 49.5223 59.0778C47.2724 56.152 49.4582 50.6967 54.4045 46.893C59.3508 43.0893 65.1845 42.3777 67.4344 45.3035Z"
  })));
};

const ForwardRef = /*#__PURE__*/forwardRef(SvgLogoMini);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/logo-mini.89b29b9d4606f0924d3dcf459aa0282b.svg";